export default {
  date: 'Tanggal',
  chooseExpDate: 'Pilih tanggal',
  filterExpDate: 'Filter berdasarkan tanggal',
  experienceType: 'Jenis',
  filterExperienceType: 'Filter berdasarkan jenis',
  experienceVibe: 'Suasana',
  filterExperienceVibe: 'Filter berdasarkan suasana',
  search: 'Cari',
  viewCalendar: 'Kalender',
  back: 'Kembali',
  previous: 'Sebelumnya',
  next: 'Berikutnya',
  noExperiences: 'Tidak Ada Pengalaman',
  cancelChanges: 'Batalkan perubahan',
  saveChanges: 'Simpan perubahan',
  removeFromReservation: 'Hapus dari reservasi',
  addToCart: 'Tambahkan ke keranjang',
  proceedToCheckout: 'Lanjutkan ke pembayaran',
  selectDate: 'Pilih tanggal',
  startDate: 'Tanggal mulai',
  endDate: 'Tanggal selesai',
  submit: 'Kirim',
  filterExperienceTypeScreenReader:
    'Gunakan filter ini untuk mempersempit hasil. Konten diperbarui secara otomatis saat filter dipilih.',
};
